export default __webpack_public_path__ + "static/media/Seguimiento_5.86b3a6a4.svg";